import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { BusinessDepotRequest } from 'src/app/models/businessDepotRequest';
import { DepotMensualite } from 'src/app/models/depot-mensualite.model';
import { DepotClientNetRequest } from 'src/app/models/DepotClientNetRequest';
import { PartenaireBaccountInfo } from 'src/app/models/partenaire-baccount-info';
import { PayService } from 'src/app/service/pay.service';
import { UserSessionService } from 'src/app/user-session.service';

@Component({
  selector: 'app-depot',
  templateUrl: './depot.component.html',
  styleUrls: ['./depot.component.css'],
  standalone: false
})
export class DepotComponent implements OnInit {
  deposit: UntypedFormGroup;
  succesmessageDepot: boolean;
  errorD1: boolean;
  errorD3: boolean;
  errorD4: boolean;
  errorD11: boolean;
  errorD12: boolean;
  errorD13: boolean;
  errorD14: boolean;
  username: string;
  depotMensualite: DepotMensualite[] = [];
  totalDepots: any;
  totalbeneficedepot: any;
  totalRetrait: any;
  totalbeneficeretrait: any;
  soldeMensuel: any;
  sigle: string;
  matriculeEmploye: string = '';
  onlydepotNetsurCompte: boolean = true;
  isSubmittingDepot: boolean = false;

  constructor(private userService: PayService, private userSessionService: UserSessionService) { }

  ngOnInit(): void {

    this.username = this.userSessionService.getUser()?.username || '';
    this.sigle = this.userSessionService.getSigle() || 'FCFA';
    console.log("Username partenaire dans depot component: ", this.userSessionService.getSigle());
    this.ngDeposit();
    this.getBaccountInformation();
    this.loadEmployeeOperationSecurity();
    // this.getMensualitePartenaire();
  }

  ngDeposit() {
    this.deposit = new UntypedFormGroup(
      {
        montan: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
        account: new UntypedFormControl('', [Validators.required, Validators.pattern('([0-9]{9}|^B[0-9]{9})$')]),
        supervisorCode: new UntypedFormControl('', [Validators.required]),
        d10000: new UntypedFormControl(0),
        d5000: new UntypedFormControl(0),
        d2000: new UntypedFormControl(0),
        d1000: new UntypedFormControl(0),
        d500: new UntypedFormControl(0)
      })
  }

  getBaccountInformation() {
    this.userService.getPartenairebAccount(this.username)
      .subscribe((data: PartenaireBaccountInfo) => {
        console.log("PartenaireBaccountInfo data:", data);
        this.soldeMensuel = data.accountBalance;
        this.totalDepots = data.sdepotPartenaire;
        this.totalbeneficedepot = data.bdepot;
        this.totalRetrait = data.sretraitPartenaire;
        this.totalbeneficeretrait = data.bretrait;

        this.getMensualitePartenaire();
      });
  }

  getMensualitePartenaire() {
    this.userService.getPartenaireMensualite(this.username)
      .subscribe((data: DepotMensualite[]) => {
        console.log("DepotMensualite data:", data);
        this.depotMensualite = data ?? [];
      });
  }

  loadEmployeeOperationSecurity() {
    this.userService.getEmployeeOperationSecurity(this.username).subscribe((data: any) => {
      this.matriculeEmploye = data?.matriculeEmploye ?? '';
      this.deposit.patchValue({ supervisorCode: data?.operationValidationCode ?? '' });
    });
  }


  /*getMensualitePartenaire() {
    this.userService.getPartenaireMensualite(this.username).subscribe((data: any[]) => {
      this.depotMensualite = data;

    })
  }*/

  depotClientNetSurComptePrimaire(formdata: any) {
    console.log("================================================ 0", formdata);
    const supervisorCode = formdata.supervisorCode?.trim() || undefined;
    const payload: DepotClientNetRequest = {
      accountNumber: Number(formdata.account),
      montant: formdata.montan, // ou Number(...)
      partnerUsername: this.username, // username du connecté (partenaire ou caissier)
      partenaireUniqueNumeroIdentification: supervisorCode,
      supervisorCode,
      billetBreakdown: this.buildBilletBreakdown(formdata)
    };
    console.log("================================================ 1", payload);
    this.userService.depotClientNetSurComptePrimaire(payload)
      .pipe(finalize(() => { this.isSubmittingDepot = false; }))
      .subscribe({
        next: data => {
          if (data === 0) {
            this.succesmessageDepot = true;
            this.getBaccountInformation();
            this.loadEmployeeOperationSecurity();
            setTimeout(() => this.succesmessageDepot = false, 4000);
          } else if (data === -1) {
            this.errorD1 = true;
            setTimeout(() => this.errorD1 = false, 4000);
          } else if (data === -3) {
            this.errorD3 = true;
            setTimeout(() => this.errorD3 = false, 4000);
          } else if (data === -4) {
            this.errorD4 = true;
            setTimeout(() => this.errorD4 = false, 4000);
          } else if (data === -11) {
            this.errorD11 = true;
            setTimeout(() => this.errorD11 = false, 6000);
          } else if (data === -12) {
            this.errorD12 = true;
            setTimeout(() => this.errorD12 = false, 6000);
          } else if (data === -13) {
            this.errorD13 = true;
            setTimeout(() => this.errorD13 = false, 6000);
          } else if (data === -14) {
            this.errorD14 = true;
            setTimeout(() => this.errorD14 = false, 6000);
          }
        },
        error: () => {
          this.errorD4 = true;
          setTimeout(() => this.errorD4 = false, 4000);
        }
      });
  }

  depotClientNetSurCompteBusiness(formdata: any) {
    console.log("================================================ 0", formdata);
    const supervisorCode = formdata.supervisorCode?.trim() || undefined;
    const payload: BusinessDepotRequest = {
      accountNumber: formdata.account,
      montant: formdata.montan, // ou Number(...)
      partnerUsername: this.username, // username du connecté (partenaire ou caissier)
      partenaireUniqueNumeroIdentification: supervisorCode,
      supervisorCode,
      billetBreakdown: this.buildBilletBreakdown(formdata)
    };

    this.userService.depotClientNetSurCompteBusiness(payload)
      .pipe(finalize(() => { this.isSubmittingDepot = false; }))
      .subscribe({
        next: data => {
          if (data == 0) {
            //success
            this.succesmessageDepot = true;
            this.getBaccountInformation();
            this.loadEmployeeOperationSecurity();
            setTimeout(() => {
              this.succesmessageDepot = false;
            }, 4000);
          }
          else if (data == -1) {
            this.errorD1 = true;
            setTimeout(() => {
              this.errorD1 = false;
            }, 4000);
          }
          else if (data == -2) {
            // ceci ne doit pas arriver
          }
          else if (data == -3) {
            this.errorD3 = true;
            setTimeout(() => {
              this.errorD3 = false;
            }, 4000);
          } else if (data === -11) {
            this.errorD11 = true;
            setTimeout(() => this.errorD11 = false, 6000);
          } else if (data === -12) {
            this.errorD12 = true;
            setTimeout(() => this.errorD12 = false, 6000);
          } else if (data === -13) {
            this.errorD13 = true;
            setTimeout(() => this.errorD13 = false, 6000);
          } else if (data === -14) {
            this.errorD14 = true;
            setTimeout(() => this.errorD14 = false, 6000);
          }
        },
        error: () => {
          this.errorD4 = true;
          setTimeout(() => this.errorD4 = false, 4000);
        }
      });
  }



  makeDeposit(formdata: any) {
    if (this.isSubmittingDepot || !this.deposit?.valid) {
      return;
    }
    this.isSubmittingDepot = true;

    //pour le moment on execute uniquement les depots sans prelevement sur le montant net depose
    const accountValue = String(this.deposit.get('account')?.value ?? '');
    if (this.onlydepotNetsurCompte) {
      if (accountValue.match('(^B[0-9]{9})')) {
        this.depotClientNetSurCompteBusiness(formdata);
        return;
      }
      else {
        this.depotClientNetSurComptePrimaire(formdata);
        return;
      }
    }

    this.isSubmittingDepot = false;

  }

  checkAccount(val) {

  }

  private buildBilletBreakdown(formdata: any): Record<string, number> {
    const breakdown: Record<string, number> = {};
    const entries: Array<[string, any]> = [
      ['10000', formdata.d10000],
      ['5000', formdata.d5000],
      ['2000', formdata.d2000],
      ['1000', formdata.d1000],
      ['500', formdata.d500]
    ];
    for (const [denomination, rawCount] of entries) {
      const count = Number(rawCount ?? 0);
      if (Number.isFinite(count) && count > 0) {
        breakdown[denomination] = Math.trunc(count);
      }
    }
    return breakdown;
  }

  get montant() { return this.deposit.get('montant'); }
  get account() { return this.deposit.get('account'); }

}
